import { HttpClient } from '@store/base';
import {
  DeleteRecentViewRequest,
  DeleteRecentViewResponse,
  GetRecentViewLatestRequest,
  GetRecentViewLatestResponse,
  GetRecentViewListRequest,
  GetRecentViewListResponse,
  GetRecentViewWeekRankRequest,
  GetRecentViewWeekRankResponse,
  SaveRecentViewRequest,
  SaveRecentViewResponse,
} from '../../model';
import { buildRecentViewQuery } from '../../utils';

const BASE_URL = `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/my/recent-views`;

export class GetRecentViewListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetRecentViewListRequest) {
    const query = buildRecentViewQuery(req.noLoginCookieUserNo, req.typeValue);

    return await this.httpClient.request<GetRecentViewListResponse>({
      method: 'GET',
      url: query ? `${BASE_URL}?${query}` : BASE_URL,
    });
  }
}

export class SaveRecentViewGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: SaveRecentViewRequest) {
    return await this.httpClient.request<SaveRecentViewResponse>({
      method: 'POST',
      url: BASE_URL,
      body: req,
    });
  }
}

export class DeleteRecentViewGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: DeleteRecentViewRequest) {
    return await this.httpClient.request<DeleteRecentViewResponse>({
      method: 'DELETE',
      url: BASE_URL,
      body: req,
    });
  }
}

export class GetRecentViewLatestGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetRecentViewLatestRequest) {
    const query = buildRecentViewQuery(req.noLoginCookieUserNo, req.typeValue);

    // STORE-MWEB-39J6: 최근 본 상품 "최신 1건" 조회는 FloatingGroup 버튼의
    // 부가 기능이라, 요청 취소/네트워크 실패가 alert(Jira 티켓화)까지 발생시킬
    // 필요는 없다 — nonCritical로 log 수준만 남긴다.
    return await this.httpClient.request<GetRecentViewLatestResponse>({
      method: 'GET',
      url: query ? `${BASE_URL}/latest?${query}` : `${BASE_URL}/latest`,
      nonCritical: true,
    });
  }
}

/** 최근 본 상품 없을 때 추천 — 이번 주 주간 베스트. 인증 불필요(typeValue만). */
export class GetRecentViewWeekRankGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetRecentViewWeekRankRequest = {}) {
    const query = buildRecentViewQuery(undefined, req.typeValue);

    return await this.httpClient.request<GetRecentViewWeekRankResponse>({
      method: 'GET',
      url: query ? `${BASE_URL}/week-rank?${query}` : `${BASE_URL}/week-rank`,
    });
  }
}
